import { render, staticRenderFns } from "./MailtplList.vue?vue&type=template&id=2ca091f7&"
import script from "./MailtplList.vue?vue&type=script&lang=js&"
export * from "./MailtplList.vue?vue&type=script&lang=js&"
import style0 from "./MailtplList.vue?vue&type=style&index=0&id=2ca091f7&prod&lang=scss&"
import style1 from "./MailtplList.vue?vue&type=style&index=1&id=2ca091f7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports